import routesData from "@/data/routes.json";
import type { PortalId, ScreenDefinition } from "@/domain/screen";

export const allScreens = routesData as unknown as ScreenDefinition[];

export function screensForPortal(portal: PortalId): ScreenDefinition[] {
  return allScreens.filter((s) => s.portal === portal);
}

export interface MainTabGroup {
  mainTab: string;
  screens: ScreenDefinition[]; // one entry per sub-tab, or a single entry if no sub-tabs
}

/** Groups a portal's screens by Main Tab, preserving the workbook's original order. */
export function groupByMainTab(portal: PortalId): MainTabGroup[] {
  const screens = screensForPortal(portal);
  const groups: MainTabGroup[] = [];
  const seen = new Map<string, MainTabGroup>();

  for (const screen of screens) {
    let group = seen.get(screen.mainTab);
    if (!group) {
      group = { mainTab: screen.mainTab, screens: [] };
      seen.set(screen.mainTab, group);
      groups.push(group);
    }
    group.screens.push(screen);
  }
  return groups;
}

export function findScreenByRoute(route: string): ScreenDefinition | undefined {
  return allScreens.find((s) => s.route === route);
}
